.buttonRowContainer {
    display: flex;
    justify-content: space-between;
}